module.exports = __webpack_public_path__ + "assets/img/re3.da2a5477.png";